var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mb-4" }, [
    _vm.label
      ? _c("label", { attrs: { for: _vm.name } }, [
          _vm._v(_vm._s(_vm.label) + "\n    "),
          _vm.tooltip && _vm.tooltip !== ""
            ? _c("span", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.tooltip,
                      autoHide: false,
                      html: true,
                      delay: 0
                    },
                    expression:
                      "{ content: tooltip, autoHide: false, html: true, delay: 0 }"
                  }
                ],
                staticClass: "fa fa-info-circle",
                attrs: { "aria-hidden": "true" }
              })
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.name === "price"
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-auto price-col" }, [
            _vm._v("\n      €\n    ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("input", {
              staticClass: "form-control",
              class: { "is-invalid": _vm.error !== "" },
              attrs: {
                type: _vm.type,
                name: _vm.name,
                id: _vm.name,
                placeholder: _vm.placeholder,
                min: _vm.min
              },
              domProps: { value: _vm.value },
              on: {
                input: function($event) {
                  return _vm.updateValue($event.target.value)
                }
              }
            })
          ])
        ])
      : _c("input", {
          staticClass: "form-control",
          class: { "is-invalid": _vm.error !== "" },
          attrs: {
            type: _vm.type,
            name: _vm.name,
            id: _vm.name,
            placeholder: _vm.placeholder,
            min: _vm.min
          },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.updateValue($event.target.value)
            }
          }
        }),
    _vm._v(" "),
    _vm.count
      ? _c(
          "small",
          {
            staticClass: "input-count",
            class: { "input-count-error": _vm.value.length > _vm.max }
          },
          [_vm._v(_vm._s(_vm.value.length) + "/" + _vm._s(_vm.max))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.error !== ""
      ? _c("div", {
          staticClass: "invalid-feedback",
          domProps: { innerHTML: _vm._s(_vm.error) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/fields/InputField.vue?vue&type=template&id=4f528cbc&
// module id = 371
// module chunks = 0